import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { retailerCollectionsV2AdminAccessControl } from '../access-control/retailerCollectionsV2AdminAccess.configuration'

// Reuse existing page components
const RetailerCollectionsV3ListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "RetailerCollectionsV3ListPage" */
      '../pages/RetailerCollectionsV3ListPage'
    )
)
const RetailerCollectionsV3CreatePage = lazy(
  () =>
    import(
      /* webpackChunkName: "RetailerCollectionsV3CreatePage" */
      '../pages/RetailerCollectionsV3CreatePage'
    )
)
const RetailerCollectionsV3ViewPage = lazy(
  () =>
    import(
      /* webpackChunkName: "RetailerCollectionsV3ViewPage" */
      '../pages/RetailerCollectionsV3ViewPage'
    )
)
const RetailerCollectionsV3EditPage = lazy(
  () =>
    import(
      /* webpackChunkName: "RetailerCollectionsV3EditPage" */
      '../pages/RetailerCollectionsV3EditPage'
    )
)

// @ts-ignore
export const retailerCollectionsAdminRouter = (
  <DomainRoute
    route="app-admin-retailer-collections"
    accessControl={retailerCollectionsV2AdminAccessControl}
  >
    <DashSwitch>
      <DomainRoute
        exact
        route="app-admin-retailer-collections-list"
        // @ts-ignore
        component={RetailerCollectionsV3ListPage}
        accessControl={retailerCollectionsV2AdminAccessControl}
      />
      <DomainRoute
        exact
        route="app-admin-retailer-collections-view"
        // @ts-ignore
        component={RetailerCollectionsV3ViewPage}
        accessControl={retailerCollectionsV2AdminAccessControl}
      />
      <DomainRoute
        exact
        route="app-admin-retailer-collections-create"
        // @ts-ignore
        component={RetailerCollectionsV3CreatePage}
        accessControl={retailerCollectionsV2AdminAccessControl}
      />
      <DomainRoute
        exact
        route="app-admin-retailer-collections-edit"
        // @ts-ignore
        component={RetailerCollectionsV3EditPage}
        accessControl={retailerCollectionsV2AdminAccessControl}
      />
    </DashSwitch>
  </DomainRoute>
)
